import Barba from 'barba.js';
import Utils from '../utils/utils.js';
import Fixes from '../utils/fixes.js';
import ServiceSVGAnimation from '../components/ServiceSVGAnimation.js';

/* eslint-disable */

export default Barba.BaseView.extend( {
	namespace: 'template-service',
	onEnter() {
		// The new Container is ready and attached to the DOM.
		const allowAnimation = false;
		const self = this;
		console.log('enter service');
		this.ScrollController = new ScrollMagic.Controller();
		
		if ( ! Utils.isMobile() && allowAnimation ){
			// jQuery( this.container ).one( 'OAX::svg-loaded:all', jQuery.proxy( this.initScrollMagic, this )  );
			
			if(!Fixes.safari.is()){
				self.initScrollMagic();
			}	

			gsap.set(
				[
					jQuery(this.container).find('.v-service__section:nth-child(3) .v-service__section-body'),
					jQuery(this.container).find('.v-service__section:nth-child(4)'),
					jQuery(this.container).find('.v-service__section:nth-child(6)')
				], {
					color: OAX.style.theme_color.base_1.hex
			});
		}
	},
	onEnterCompleted() {
		// The Transition has just finished.
	},
	onLeave() {

	},
	onLeaveCompleted() {
		// The Container has just been removed from the DOM.
	},
	initScrollMagic(){
		const self = this;

		ServiceSVGAnimation.init(this.container);
		const svg = ServiceSVGAnimation.svg;

		/**
		 * Infowagen
		 */
		const $infowagenSection = jQuery(this.container).find('.v-service__section:nth-child(1)');
		const infowagenAnimationOnVisible = ServiceSVGAnimation.animateInfowagen();
		const infowagenAnimationBuildUp = gsap.timeline({
			paused : true,
			force3D : true
		});
		const infowagenAnimationBuildUpStaggerEls = svg.infowagen.$group.find('#Vogel_an-2');
		infowagenAnimationBuildUp
			.from(infowagenAnimationBuildUpStaggerEls, 1, {
				autoAlpha : 0
			}, 0)
			.add(ServiceSVGAnimation.animateInfowagenWagen(), 0);
			/*
			.from($infowagenSection, 0.35, {
				autoAlpha : 0,
				x : 20
			}, '-=1.5');			
			*/

		const promiseInfowagenAnimationBuildUp = Utils.timelinePromise(infowagenAnimationBuildUp, 0.8);
		let buildUpDuration = infowagenAnimationBuildUp.duration();

		new ScrollMagic.Scene({
			triggerElement : $infowagenSection.get(0),
			triggerHook : 0.5,
			duration : jQuery(window).height() * 0.8,
		})
		.on('enter leave', function(event){
			if(event.type === 'enter' && event.scrollDirection === 'FORWARD'){ // in from top
				infowagenAnimationBuildUp.duration(buildUpDuration);
				infowagenAnimationBuildUp.play();
				infowagenAnimationOnVisible.play();
				// promiseInfowagenAnimationBuildUp.then(() => {
				// 	infowagenAnimationOnVisible.play();
				// });
			} else if(event.type === 'leave' && event.scrollDirection === 'FORWARD'){ // out from top
				infowagenAnimationOnVisible.pause();
				infowagenAnimationOnVisible.progress(0, false);
			} else if(event.type === 'enter' && event.scrollDirection === 'REVERSE'){ // in from bottom
				infowagenAnimationOnVisible.play();
			} else if(event.type === 'leave' && event.scrollDirection === 'REVERSE'){ // out from bottom
				infowagenAnimationOnVisible.pause();
				infowagenAnimationOnVisible.progress(0, false);				
				
				infowagenAnimationBuildUp.duration(buildUpDuration / 4);
				infowagenAnimationBuildUp.reverse();
			}
			// console.log(event);
		})
		//.addIndicators()
		.addTo(self.ScrollController);

		/**
		 * Ticketservice
		 */
		const $ticketserviceSection = jQuery(this.container).find('.v-service__section:nth-child(2)');
		const ticketserviceAnimationOnVisible = ServiceSVGAnimation.animateTicketservice();
		const ticketserviceAnimationBuildUp = gsap.timeline({
			paused : true,
			force3D : true
		});
		
		const $ticketserviceStaggerEls = svg.ticketservice.$group.find('#Vogel_an');

		ticketserviceAnimationBuildUp
			.staggerFrom($ticketserviceStaggerEls, 1, {
				autoAlpha : 0
			}, 0.2, 0)
			.add(ServiceSVGAnimation.animateTicketserviceHaus(), '-=0.2')
			.add(ServiceSVGAnimation.animateTicketserviceTicketFlight());			

		const promiseTicketserviceAnimationBuildUp = Utils.timelinePromise(ticketserviceAnimationBuildUp, 0.8);
		let ticketserviceBuildUpDuration = ticketserviceAnimationBuildUp.duration();
		
		/*
		new ScrollMagic.Scene({
			triggerElement : ServiceSVGAnimation.svg.ticketservice.schlange.$path.get(0),
			triggerHook : 0.9,
			duration : 600,
		})
		.setTween(ServiceSVGAnimation.animateTicketserviceTicketschlangePath())
		.addTo(self.ScrollController);			
		*/

		new ScrollMagic.Scene({
			triggerElement : $ticketserviceSection.get(0),
			triggerHook : 0.75,
			duration : jQuery(window).height() * 0.75,
		})
		.on('enter leave', function(event){
			if(event.type === 'enter' && event.scrollDirection === 'FORWARD'){ // in from top
				ticketserviceAnimationBuildUp.duration(ticketserviceBuildUpDuration);
				ticketserviceAnimationBuildUp.play();
				promiseTicketserviceAnimationBuildUp.then(() => {
					ticketserviceAnimationOnVisible.play();
				});
			} else if(event.type === 'leave' && event.scrollDirection === 'FORWARD'){ // out from top
				ticketserviceAnimationOnVisible.pause();
				ticketserviceAnimationOnVisible.progress(0, false);
			} else if(event.type === 'enter' && event.scrollDirection === 'REVERSE'){ // in from bottom
				ticketserviceAnimationOnVisible.play();
			} else if(event.type === 'leave' && event.scrollDirection === 'REVERSE'){ // out from bottom
				ticketserviceAnimationOnVisible.pause();
				ticketserviceAnimationOnVisible.progress(0, false);				
				
				ticketserviceAnimationBuildUp.duration(ticketserviceBuildUpDuration / 4);
				ticketserviceAnimationBuildUp.reverse();
			}
		})
		.setTween(ServiceSVGAnimation.animateTicketserviceBirdPath())
		//.addIndicators()
		.addTo(self.ScrollController);
		
		/**
		 * Unwetter
		 */
		const $unwetterSection = jQuery(this.container).find('.v-service__section:nth-child(3)');
		const unwetterAnimationOnVisible = ServiceSVGAnimation.animateUnwetter();
		const unwetterAnimationBuildUp = gsap.timeline({
			paused : true,
			force3D : true
		});

		/*
		const unwetterAnimationBuildUpStaggerEls = svg.unwetter.$group.find('#Baum_klein, #Schild_Achtung_');
		unwetterAnimationBuildUp
			.staggerFrom(unwetterAnimationBuildUpStaggerEls, 1, {
				autoAlpha : 0
			}, 0.2, 0);
		*/

		const promiseUnwetterAnimationBuildUp = Utils.timelinePromise(unwetterAnimationBuildUp, 0.8);
		let unwetterBuildUpDuration = unwetterAnimationBuildUp.duration();		

		new ScrollMagic.Scene({
			triggerElement : $unwetterSection.get(0),
			triggerHook : 0.9,
			duration : jQuery(window).height() * 0.9,
		})
		.on('enter leave', function(event){
			if(event.type === 'enter' && event.scrollDirection === 'FORWARD'){ // in from top
				unwetterAnimationBuildUp.duration(unwetterBuildUpDuration);
				unwetterAnimationBuildUp.play();
				unwetterAnimationOnVisible.play();
				/*
				promiseUnwetterAnimationBuildUp.then(() => {
					unwetterAnimationOnVisible.play();
				});
				*/
			} else if(event.type === 'leave' && event.scrollDirection === 'FORWARD'){ // out from top
				unwetterAnimationOnVisible.pause();
				unwetterAnimationOnVisible.progress(0, false);
			} else if(event.type === 'enter' && event.scrollDirection === 'REVERSE'){ // in from bottom
				unwetterAnimationOnVisible.play();
			} else if(event.type === 'leave' && event.scrollDirection === 'REVERSE'){ // out from bottom
				unwetterAnimationOnVisible.pause();
				unwetterAnimationOnVisible.progress(0, false);				
				
				unwetterAnimationBuildUp.duration(unwetterBuildUpDuration / 4);
				unwetterAnimationBuildUp.reverse();
			}
		})
		// .addIndicators()
		.addTo(self.ScrollController);

		/**
		 * Info
		 */
		const $infoSection = jQuery(this.container).find('.v-service__section:nth-child(4)');
		const infoAnimationOnVisible = ServiceSVGAnimation.animateInfo();
		const infoAnimationBuildUp = gsap.timeline({
			paused : true,
			force3D : true
		});

		const infoAnimationBuildUpStaggerEls = svg.info.$group.find('#Baum_klein, #Schild_Achtung_');
		infoAnimationBuildUp
			.add(ServiceSVGAnimation.animateInfoIcons(), 0);

		const promiseInfoAnimationBuildUp = Utils.timelinePromise(infoAnimationBuildUp, 0.8);
		let infoBuildUpDuration = infoAnimationBuildUp.duration();		

		new ScrollMagic.Scene({
			triggerElement : $infoSection.get(0),
			triggerHook : 0.9,
			duration : jQuery(window).height() * 1.6,
		})
		.on('enter leave', function(event){
			if(event.type === 'enter' && event.scrollDirection === 'FORWARD'){ // in from top
				infoAnimationBuildUp.duration(infoBuildUpDuration);
				infoAnimationBuildUp.play();
				infoAnimationOnVisible.play();
				/*
				promiseInfoAnimationBuildUp.then(() => {
					infoAnimationOnVisible.play();
				});
				*/
			} else if(event.type === 'leave' && event.scrollDirection === 'FORWARD'){ // out from top
				infoAnimationOnVisible.pause();
				infoAnimationOnVisible.progress(0, false);
			} else if(event.type === 'enter' && event.scrollDirection === 'REVERSE'){ // in from bottom
				infoAnimationOnVisible.play();
			} else if(event.type === 'leave' && event.scrollDirection === 'REVERSE'){ // out from bottom
				infoAnimationOnVisible.pause();
				infoAnimationOnVisible.progress(0, false);				
				
				infoAnimationBuildUp.duration(infoBuildUpDuration / 4);
				infoAnimationBuildUp.reverse();
			}
		})
		// .addIndicators()
		.addTo(self.ScrollController);		

		/**
		 * Veranstalter / Presse
		 */
		const $presseSection = jQuery(this.container).find('.v-service__section:nth-child(5)');
		const presseAnimationOnVisible = ServiceSVGAnimation.animatePresse();
		const presseAnimationBuildUp = gsap.timeline({
			paused : true,
			force3D : true
		});

		const presseAnimationBuildUpStaggerEls = svg.info.$group.find('#Baum_klein, #Schild_Achtung_');
		// presseAnimationBuildUp.add(ServiceSVGAnimation.animateInfoIcons(), 0);

		const promisePresseAnimationBuildUp = Utils.timelinePromise(presseAnimationBuildUp, 0.8);
		let presseBuildUpDuration = presseAnimationBuildUp.duration();		

		new ScrollMagic.Scene({
			triggerElement : $presseSection.get(0),
			triggerHook : 0.9,
			duration : jQuery(window).height() * 0.9,
		})
		.on('enter leave', function(event){
			if(event.type === 'enter' && event.scrollDirection === 'FORWARD'){ // in from top
				presseAnimationBuildUp.duration(presseBuildUpDuration);
				presseAnimationBuildUp.play();
				presseAnimationOnVisible.play();
				/*
				promiseInfoAnimationBuildUp.then(() => {
					infoAnimationOnVisible.play();
				});
				*/
			} else if(event.type === 'leave' && event.scrollDirection === 'FORWARD'){ // out from top
				presseAnimationOnVisible.pause();
				presseAnimationOnVisible.progress(0, false);
			} else if(event.type === 'enter' && event.scrollDirection === 'REVERSE'){ // in from bottom
				presseAnimationOnVisible.play();
			} else if(event.type === 'leave' && event.scrollDirection === 'REVERSE'){ // out from bottom
				presseAnimationOnVisible.pause();
				presseAnimationOnVisible.progress(0, false);				
				
				presseAnimationBuildUp.duration(presseBuildUpDuration / 4);
				presseAnimationBuildUp.reverse();
			}
		})
		// .addIndicators()
		.addTo(self.ScrollController);
	}
} );
